import React from 'react';
import '../../scss/components/Datepicker.scss';

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { de } from 'date-fns/locale/de';
import CalendarIcon from '../../img/inline/CalendarIcon.tsx';

const Datepicker = (props:any) => {

    registerLocale('de', de)

    let dateProps = Object.create(props);
    if (!dateProps.labelPosition) {
        dateProps.labelPosition = 'before';
    }
    return (
        <div className={`form-group datepicker${dateProps.wrapperClassName ? ' ' + dateProps.wrapperClassName : ''}`}>
            {dateProps.label && dateProps.label.length > 0 && dateProps.labelPosition === 'before' ? (
                <label htmlFor={dateProps.name}>{dateProps.label} {dateProps.isRequired ? '*' : ''}</label>
            ) : <></>}
            <DatePicker
                type='date'
                chooseDayAriaLabelPrefix='Auswählen'
                ariaLabelClose='Schließen'
                nextYearAriaLabel='Nächstes Jahr'
                nextMonthAriaLabel='Nächster Monat'
                previousMonthAriaLabel='Vorheriger Monat'
                previousYearAriaLabel='Vorheriges Jahr'
                ariaLabel={dateProps.label + (dateProps.isRequired ? ' (Erforderlich)' : '')}
                showIcon
                icon={<CalendarIcon />}
                className={(props.error ? ' invalid' : '')}
                {...props}
            />
            {dateProps.label && dateProps.label.length > 0 && dateProps.labelPosition === 'after' ? (
                <label htmlFor={dateProps.name}>{dateProps.label} {dateProps.isRequired ? '*' : ''}</label>
            ) : <></>}
            { props.error && (
                <span className='form-error' role='alert'>{ props.error }<br></br></span>
            ) }
        </div>
    )
}

export default Datepicker;
